import { useQueryClient } from 'react-query';
import { toast } from 'react-toastify';

import { ActionButton } from 'app/components/Button/ActionButton';
import { useListView } from 'app/components/Table/core/ListViewProvider';
import { useQueryResponse } from 'app/components/Table/core/QueryResponseProvider';
import { emptyListViewProvider } from 'app/components/Table/core/constants';
import Typography from 'app/components/Typography';

import { getResponseError } from 'app/helpers/errors';
import { useBoolean } from 'app/hooks';

import { STATUS_USER } from '../core/constants';
import { changeStatusUser } from '../core/requests';

interface Props {
  nameQuery: string;
  originalData: any;
}

const FormChangeStatusCard: React.FC<Props> = ({ nameQuery, originalData }) => {
  const { refetch, query } = useQueryResponse();
  const { setItemForUpdate } = useListView();
  const queryClient = useQueryClient();
  const loading = useBoolean(false);
  const labelStatus = originalData.status === STATUS_USER.ACTIVATE ? 'Inactivate' : 'Activate';
  const cancel = (withRefresh?: boolean) => {
    if (withRefresh) {
      refetch();
    }
    setItemForUpdate(emptyListViewProvider);
  };

  const onSubmit = async () => {
    loading.setValue(true);

    try {
      await changeStatusUser(originalData?.id, {
        activate:
          originalData.status === STATUS_USER.ACTIVATE
            ? STATUS_USER.DEACTIVATE
            : STATUS_USER.ACTIVATE,
      });
      refetch();
      toast.success(`${labelStatus} account successfully!`);

      queryClient.invalidateQueries([`${nameQuery}-${query}`]);
    } catch (error: any) {
      getResponseError(error);
    } finally {
      loading.setValue(false);
      cancel();
    }
  };

  return (
    <div className="d-flex flex-column">
      <Typography variant="body-3">
        {`Are you sure to ${labelStatus.toLocaleLowerCase()} this account?`}
      </Typography>
      <ActionButton
        onCancel={cancel}
        onSubmit={onSubmit}
        themeButton={originalData.status === STATUS_USER.ACTIVATE ? 'btn-danger' : 'btn-primary'}
        labelButtonSubmit={labelStatus}
        isSubmitting={loading.value}
      />
    </div>
  );
};
export default FormChangeStatusCard;
